import React from 'react';
import {
    BrowserRouter as Router, Switch, Route, Redirect
} from "react-router-dom";
import Layout from "../Areas/Layout/containers/layoutContainer"
import RouterPlanHandle from '../Areas/PlanHandle/routers';
import RouterPlanTemplate from '../Areas/PlanTemplate/routers';
import RouterLogin from '../Areas/Login/routers';
import RouterMenuAuthorization from '../Areas/MenuAuthorization/routers';
import RouterMenuRole from '../Areas/MenuRole/routers';
import RouterMenuUser from '../Areas/MenuUser/routers';
import Cookies from 'universal-cookie';
import RouterDashboard from '../Areas/Dashboard/routers';
import RouterHomePage from '../Areas/HomePage/router';
import RouterConfirmPage from '../Areas/HomeConfirm/routers';

const cookies = new Cookies();
//IndexImportHygen
function rootRouters() {
    return (
        <Router>
            <Switch>
                <Route path="/Login">
                    <RouterLogin/>
                </Route>
                <Route path ="/ConfirmPage">
                    <RouterConfirmPage/>
                </Route>
                <PrivateRoute path="/">
                    <Layout>
                        <RouterHomePage/>
                        <RouterPlanTemplate/>
                        <RouterPlanHandle/>
                        <RouterMenuAuthorization/>
                        <RouterMenuRole/>
                        <RouterMenuUser/>
                        <RouterDashboard />
                    </Layout>
                </PrivateRoute>
                        
                {/* IndexUsingHygen */}
            </Switch>
        </Router>
    );
}
function PrivateRoute({ children, ...rest }) {
  var isAuthenticated = cookies.get('usercode');
    return (
        <Route
            {...rest}
            render={({ location }) =>
                isAuthenticated ? (
                    children
                ) : (
                        <Redirect
                            to={{
                                pathname: "/Login",
                                state: { from: location }
                            }}
                        />
                    )
            }
        />
    );
}
export default rootRouters;
